import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { UserService } from '../services/user.service';
import { WebStorageService } from '../services/webstorage.service';
import { Utils } from '../helper/Utils';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private router: Router,
    private userService: UserService,
    private webStorageService: WebStorageService,
  ) {}
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkUserLogin(route, state);
    // const currentUser = this.authenticationService.currentUserValue;
    // if (currentUser && currentUser['token_type'] == 'bearer') {
    //   // authorised so return true
    //   return true;
    // }

    // // not logged in so redirect to login page with the return url
    // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    // return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  checkUserLogin(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let segments = route.url.map(segment => segment.path);
    if(segments && segments.length>0)
    {
      if(segments.includes('audio') || segments.includes('file'))
      {
        let userdata=this.webStorageService.getItemFromLocalStorage('user')
       // console.log( Utils.fetch('clientAbbreviation'))
        if(userdata && userdata['UserID'] >= 0 && segments.includes( Utils.fetch('clientAbbreviation'))){

          this.webStorageService.setItemInSessionStorage('ASPNET_SessionId', this.webStorageService.getItemFromLocalStorage('ASPNET_SessionId'));
          this.webStorageService.setItemInSessionStorage('token', this.webStorageService.getItemFromLocalStorage('token'));
          this.webStorageService.setItemInSessionStorage('company', this.webStorageService.getItemFromLocalStorage('company'));
          this.webStorageService.setItemInSessionStorage('SessionID', this.webStorageService.getItemFromLocalStorage('SessionID'));
          return true
        }
      }
    }
    if (this.userService.isLoggedIn()) {
      return true;
      /*
      const userGroups = this.authenticationService.getGroups();
      let userRoles = _.pluck(userGroups, 'user_role');
      userRoles = _.each(userRoles, (role, key) => {
        userRoles[key] = (role as String).toLowerCase();
      });
      const matchedRole = _.intersection(userRoles, route.data['roles']);

      // check if routes are for admin
      if (state.url.indexOf('admin') !== -1 && route.data['roles'] != null) {
        if (_.contains(matchedRole, 'admin')) {
          return true;
        } else {
          // redirect to user / manager landing page
          this.router.navigate(['/dashboard'])
          return false;
        }
      } else {
        if (
          _.contains(matchedRole, 'user') ||
          _.contains(matchedRole, 'manager')
          ) {
          return true;
        } else {
          // redirect to admin landing page
          this.router.navigate(['/admin'])
          return false;
        }
      }*/
    }

    // not logged in so redirect to login page with the returnUrl (preserve filePath)
    let returnUrl = state.url || '';
    if (segments && segments.length > 0 && (segments.includes('audio') || segments.includes('file'))) {
      const queryparam = decodeURIComponent(route.queryParams['filePath'] || '');
      // persist redirect target as a fallback (use WebStorageService which handles errors)
      this.webStorageService.setItemInLocalStorage('returnUrl', returnUrl);
      if (queryparam) this.webStorageService.setItemInLocalStorage('returnFilePath', queryparam);
      this.router.navigate(['login'], { queryParams: { returnUrl: returnUrl, filePath: queryparam } });
    } else {
      this.webStorageService.setItemInLocalStorage('returnUrl', returnUrl);
      this.webStorageService.setItemInLocalStorage('returnFilePath', null);
      this.router.navigate(['login'], { queryParams: { returnUrl: returnUrl } });
    }
    return false;
  }
}
